import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Table from '../../../core/form/Table';
import Async from '../../../core/layout/Async';
import Button from '../../../core/form/Button';
import Select from '../../../core/form/Select';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import Separator from '../../../core/layout/Separator';
import FormButtons from '../../../core/form/FormButtons';
import InstructionVideoUploadFormContainer from './InstructionVideoUploadFormContainer';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import Card from '../../../core/layout/Card';
import { browserHistory } from 'react-router';

const InstructionVideoForm = (props) => {
  const handleDeleteInstruction = (locale) => {
    ConfirmationDialogService.show(
      'Delete Locale Instruction Video',
      `You are about to delete the Instruction Video from locale "${locale}", Do you want to continue ?`,
      () => props.onDelete(locale)
    );
  };

  return (
    <>
      <Card
        title={get(props.values, 'id') ? 'Edit Instruction Video' : 'Add Instruction Video'}
        actions={<Button type="default" icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            props.onSubmit();
          }}
        >
          <Row>
            <Column size={1.5}>
              <Select
                required
                label="Type"
                disabled={props.loading || props.submitting || !!get(props.values, 'id')}
                value={get(props.values, 'type')}
                onChange={(value) => props.onChange('type', value)}
                errorText={get(props.errors, 'type')}
                options={[
                  {
                    label: 'Student',
                    value: 'STUDENT',
                  },
                  {
                    label: 'Kids',
                    value: 'KIDS',
                  },
                  {
                    label: 'Parent',
                    value: 'PARENT',
                  },
                ]}
              />
            </Column>
            <Column size={3}>
              <TextInput
                required
                label="Key"
                disabled={props.loading || props.submitting || !!get(props.values, 'id')}
                value={get(props.values, 'key')}
                onChange={(value) => props.onChange('key', value)}
                errorText={get(props.errors, 'key')}
              />
            </Column>
          </Row>
          <Separator />
          {!get(props.values, 'id') && (
            <FormButtons
              confirmLabel={`${get(props.values, 'id') ? 'Update' : 'Create'} Instruction Video`}
              isDisabled={props.submitting || props.loading}
              isSubmitting={props.submitting}
              onReset={props.onReset}
            />
          )}
        </form>
      </Card>
      <Separator size="sm" />
      {get(props.values, 'id') && (
        <Card title="Add Instruction Video to Locale">
          <Async fetching={props.loading}>
            <>
              <InstructionVideoUploadFormContainer
                instructionVideoId={get(props.values, 'id')}
                selectedLocales={get(props.values, 'instructions', []).map((instruction) => instruction.locale)}
              />
              <Row>
                <Column size={12}>
                  <Table
                    columns={[
                      {
                        label: 'Locale',
                        path: 'locale',
                        width: '80px',
                        sort: true,
                      },
                      {
                        label: 'Title',
                        path: 'videoTitle',
                      },
                      {
                        label: 'Link',
                        path: 'videoLink',
                        render: (cell, row) => (
                          <a target="_blank" rel="noopener noreferrer" href={cell}>
                            {cell}
                          </a>
                        ),
                      },
                      {
                        label: 'Actions',
                        path: 'action',
                        width: '90px',
                        render: (cell, row) => (
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button icon="edit" onClick={() => props.onEdit(row.locale)} />
                            <Button icon="delete" onClick={() => handleDeleteInstruction(row.locale)} />
                          </div>
                        ),
                      },
                    ]}
                    rows={get(props.values, 'instructions', [])}
                    showTableCount={false}
                  />
                </Column>
              </Row>
            </>
          </Async>
        </Card>
      )}
    </>
  );
};

InstructionVideoForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  values: PropTypes.object,
  loading: PropTypes.bool,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
};

InstructionVideoForm.defaultProps = {
  values: {},
  loading: false,
  submitting: false,
  errors: {},
};

export default InstructionVideoForm;
